/* eslint-disable react/no-unknown-property */
import { Modal } from '@material-ui/core';

const ModalVideo = ({ isOpen, handleClose, videoId }) => (
  <Modal
    open={isOpen}
    onClose={handleClose}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    className="c-video-modal">
    <iframe
      width="100%"
      height="100%"
      autoplay
      src={`https://www.youtube.com/embed/${videoId}`}
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen></iframe>
  </Modal>
);

export default ModalVideo;
